import { render, staticRenderFns } from "./ServiceRequestReports.vue?vue&type=template&id=449505a1&scoped=true&"
import script from "./ServiceRequestReports.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449505a1",
  null
  
)

export default component.exports